import { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// @mui material components
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React context
import { useMaterialUIController, setOpenConfigurator } from "context";

// Custom components
import TelegramIcon from "components/TelegramIcon";

// Services
import { getTelegramId } from "services/referentService";

function MobileBottomNav({ vehicleData, referent }) {
  const [controller, dispatch] = useMaterialUIController();
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleConfiguratorOpen = () => {
    setOpenConfigurator(dispatch, true);
  };

  const handleVehicleClick = () => {
    // Vous pouvez modifier cette fonction selon vos besoins
    // Par exemple: ouvrir un modal, naviguer vers une page, etc.
    console.log("Véhicule clicked", vehicleData);
    // navigate("/vehicle"); // Si vous avez une page véhicule
  };

  const handleTelegramClick = async () => {
    // Récupérer l'ID Telegram du référent
    const telegramId = await getTelegramId(referent);

    // Ouvrir Telegram avec l'ID du référent
    const url = `https://t.me/${telegramId.replace('@', '')}`;
    window.open(url, "_blank");
  };

  return (
    <Box
      sx={{
        display: { xs: "block", lg: "none" },
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          borderRadius: "24px 24px 0 0",
          background: "linear-gradient(195deg, #42424a 0%, #191919 100%)",
          backdropFilter: "blur(10px)",
        }}
      >
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{
            background: "transparent",
            borderRadius: "24px 24px 0 0",
            height: "80px",
            "& .MuiBottomNavigationAction-root": {
              color: "rgba(255, 255, 255, 0.6)",
              minWidth: "auto",
              padding: "16px 16px 12px 16px",
              minHeight: "80px",
            },
            "& .MuiBottomNavigationAction-root.Mui-selected": {
              color: "#fff",
            },
            "& .MuiBottomNavigationAction-label": {
              fontSize: "0.75rem",
              marginTop: "6px",
              fontWeight: "500",
            },
            "& .MuiBottomNavigationAction-label.Mui-selected": {
              fontSize: "0.8rem",
              fontWeight: "600",
            },
            "& .MuiSvgIcon-root, & .MuiIcon-root": {
              fontSize: "2rem !important",
            },
          }}
        >
          <BottomNavigationAction
            label="Paramètres"
            icon={<Icon>settings</Icon>}
            onClick={handleConfiguratorOpen}
          />
          <BottomNavigationAction
            label="Véhicule"
            icon={<Icon>directions_car</Icon>}
            onClick={handleVehicleClick}
          />
          <BottomNavigationAction
            label="Telegram"
            icon={<TelegramIcon />}
            onClick={handleTelegramClick}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

MobileBottomNav.propTypes = {
  vehicleData: PropTypes.object,
  referent: PropTypes.string,
};

MobileBottomNav.defaultProps = {
  vehicleData: null,
  referent: null,
};

export default MobileBottomNav;
